<template lang="pug">
  app-page(:fabItems="fabItems" title="Почтовые отправления" @search="text => (search = text.toLowerCase())")
    app-toolbar(title="Список почтовых отправлений")
      app-toolbar-item.ml-12(label="Фильтровать" :items="filterItems" key-name="title" min-width="177" @select="setFilterByIndex") {{ filter.title }}
      app-toolbar-item.ml-12(label="Сортировать" :items="sorterItems" key-name="title" min-width="177" @select="setSorterByIndex") {{ sorter.title }}
    
    .text-right
      v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
      v-chip.ma-2(v-if="filter.status" color="#757575" text-color="white" small label close @click:close="setFilterByIndex(null, 0)") Фильтр:&nbsp;<b>{{ filter.title }}</b>

    v-layout
      v-flex(xs6 mr-2)
        app-sublayer
          app-sublayer-header В обработке
          app-empty-list(v-if="unformedLetters.length == 0") Список пуст
          app-group-animation
            app-group-item(v-for="l in unformedLetters" :key="l.id" cols="12")
              letters-card( :letter="l" :sorter-key="sorter.key" @click.native="dialogLetter(l)")
          //- v-scale-transition(group)
            letters-card(v-for="l in unformedLetters" :key="l.id" :letter="l" :sorter-key="sorter.key" @click.native="dialogLetter(l)")
      
      v-flex(xs6 ml-2)
        app-sublayer
          app-sublayer-header Готовые
          app-empty-list(v-if="preparedLetters.length == 0") Список пуст
          app-group-animation
            app-group-item(v-for="l in preparedLetters" :key="l.id" cols="12")
              letters-card(:letter="l" :sorter-key="sorter.key" :search="search" @click.native="dialogLetter(l)")
          //- v-scale-transition(group)
            letters-card(v-for="l in preparedLetters" :key="l.id" :letter="l" :sorter-key="sorter.key" @click.native="dialogLetter(l)")

    app-dialog(v-model="dialog.letter" :items="letterItems" header="Выбранный пакет документов")

    app-dialog(v-model="dialog.props" :header="!letter.id ? 'Добавить отправление' : 'Изменить параметры отправления'")
      v-form(v-if="showPropsContent" ref="newLetterForm")
        div(v-if="!letter.id")
          v-autocomplete(
            v-model="letter.courtCase"
            :items="cases"
            :loading="isLoading"
            :search-input.sync="searchNumber"
            hide-no-data
            hide-selected
            item-text="number"
            label="Поиск дела"
            placeholder="Начните набирать номер дела"
            append-icon="mdi-database-search"
            return-object
            outlined
            @change="getCase()"
          )
          app-select(:disabled="!caseMembers" v-model="caseMember" :items="caseMembers" label="Участник" item-text="name" @input="getDataMemebers()" return-object)
          app-select(v-model="letter.mailType" :items="mailTypesList" label="Тип отправления" item-text="title")
        
        app-text-field(
          v-model="letter.weight" label="Грамм" 
          :rules="[weightChecker]"
          append-outer-icon="add"     @click:append-outer="incrementWeight"
          prepend-outer-icon="remove" @click:prepend-outer="decrementWeight"
        ) 
        app-select(v-if="isMailTypeLetter()" v-model="letter.envelopeFormat" :items="envelopeFormats" label="Формат" item-text="title" item-value="name")
        app-text-field(v-model="letter.addressee" label="ФИО получателя") 
        app-text-field(v-model="letter.address" label="Адрес") 
        v-checkbox(v-model="letter.noticeOrdered" label="С заказным уведомлением") 

        app-button-action(@click="changeLetter()") Далее

    app-dialog-confirm(v-model="dialog.confirm" confirm-button="продолжить" @confirm="updateLetterProps")
      app-card-title При изменение адреса или адресата доставки будет изменен ШПИ конверта

    app-dialog-confirm(v-model="dialog.delete" ref="deleteLetter" confirm-button="продолжить" @confirm="deleteLetter")
      app-card-title Вы точно хотите удалить это почтовое отправление?

    app-button-action(@click="sendPreparedLetters()" fixed bottom center) Передать готовые для формирования реестра
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import $_app_sessionDoc from "@/common/AppSessionDoc.js"
import { AppDialogConfirm } from '@/components'

import { letterService, memberService, caseService, userService } from '@/_services'

import { $_validate_rules } from '@/common/ValidateRules'
import refreshable from '@/common/Refreshable'
import { $_app_server } from '@/_helpers'

import LettersCard from './components/LettersCard'
import LetterStatus from './components/LetterStatus'

export default {
  mixins: [$_app_sessionDoc, $_validate_rules, refreshable],

  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    LettersCard
  },
  
  mounted () {
    this.init()
  },

  methods: {
    ...mapMutations('letter', ['setSorterIndex', 'setFilterIndex', 'moveLetter']),
    ...mapActions('letter', ['init', 'refresh', 'requestEnvelope', 'updateLetter', 'prepareToRegistry', 'remove', 'createLetter', 'loadLetters']),

    $_refresh () {
      this.refresh().then(() => {
        // if (this.letter !== undefined && this.letter.id) {
        //   this.letter = this.letters.find(item => item.id == this.letter.id)
        // }
      })
    },

    deleteLetter () {
      this.remove(this.letter)
    },

    changeLetter () {
      if (this.$refs.newLetterForm.validate()) {
        this.moveLetter(this.letter)
        this.dialog.props = false
        this.dialog.letter = false
        if (!this.letter.status.value) this.newLetterProps()
        else if ([0, 7].includes(this.letter.status.value) || (this.letter.addressee == this.letter.addresseeDefault && this.letter.address == this.letter.addressDefault))
          this.updateLetterProps()
        else this.dialog.confirm = true
      }
    },

    newLetterProps () {
      letterService.newLetter(this.letter).then(letter => {
         this.createDafaultDoc(letter.id)
      })
    },

    updateLetterProps () {
      this.updateLetter(this.letter)
    },

    prepareLetterToRegistry () {
      this.dialog.letter = false
      this.prepareToRegistry(this.letter)
    },

    dialogLetter (l) {
      this.letter = JSON.parse(JSON.stringify(l))
      this.letter.addresseeDefault = this.letter.addressee
      this.letter.addressDefault = this.letter.address

      if (l.error) this.dialog.props = true
      else this.dialog.letter = true
    },

    dialogProps () {
      this.dialog.props = true
    },

    handleEnvelopeByStatus () {
      if (this.letter.status.name == LetterStatus.formed) {
        // let noticeLink = `${$_app_server.defaults.baseURL}letters/${this.letter.id}/notice`
        let envelopeLink = `${$_app_server.defaults.baseURL}letters/${this.letter.id}/envelope`
        window.open(envelopeLink, '_blank') 
      }
      else if (this.letter.status.name == LetterStatus.new || this.letter.status.name == LetterStatus.error || this.letter.status.name == LetterStatus.communication_error) {
        this.requestEnvelope(this.letter)
      }
    },

    generateConvert () {
      if (this.letter.status.name == LetterStatus.formed) {
        let envelopeLink = `${$_app_server.defaults.baseURL}letters/${this.letter.id}/pdf` + localStorage.getItem("courtAlias")
        window.open(envelopeLink, '_blank') 
      }
      else if (this.letter.status.name == LetterStatus.new || this.letter.status.name == LetterStatus.error || this.letter.status.name == LetterStatus.communication_error) {
        this.requestEnvelope(this.letter)
      }
    },

    setFilterByIndex (item, index) {
      this.setFilterIndex(index)
    },

    setSorterByIndex (item, index) {
      this.setSorterIndex(index)
    },

    filterByJudge (list) {
      let grants = JSON.parse(localStorage.getItem("grants")).filter(item => item.grantType =="JUDGE" || item.grantType =="JUDGEHELPER")

      if (!userService.existRole("POSTWORKER"))
        if (grants.length > 0) list = list.filter(item => item.judge && item.judge.id == grants[0].locationObj)
      return list
    },

    sendPreparedLetters () {
        this.preparedLetters.map(item => this.prepareToRegistry(item))
    },

    isMailTypeLetter () {
      return this.letter.mailType && this.letter.mailType.name.indexOf("LETTER") != -1 ? true : false
    },

    getDataMemebers () {
      if (this.caseMember && this.caseMember.name) this.letter.addressee = this.caseMember.name
      if (this.caseMember && this.caseMember.address) this.letter.address = this.caseMember.address
    },

    createDafaultDoc (letterId) {
      let caseSessions = this.letter.courtCase.caseSessions ? this.letter.courtCase.caseSessions.sort((a, b) => b.eventDate.localeCompare(a.eventDate)) : []
      if (this.caseMember) 
          memberService.personaAlertsLetter(letterId, { 
            caseMembers: this.caseMember ? [this.caseMember.id] : [],
            caseSessionId: this.letter.courtCase ? caseSessions[0].id : '',
            docTemplateId: null,
            name: "Добавлено из почтового кабинета",
            fileName: "Добавлено из почтового кабинета"
          })
      this.loadLetters()
    },

    showNewLetter() {
      this.clearLetterForm()
      this.dialog.props = true
    },

    clearLetterForm () {
      this.cases = []
      this.caseMember = ""
      this.letter = Object.assign({}, this.letterDefault)
      this.letter.status= {value: 0, title: "Новое", name: "START"}
    },

    getCase() {
      caseService.showWithMemberAndSession(this.letter.courtCase.id).then(data => this.letter.courtCase = data)
    },

    incrementWeight () {
      this.letter.weight = this.weight * 1 + 1
    },

    decrementWeight () {
      this.letter.weight = this.weight * 1 > this.minWeight ? this.weight * 1 - 1 : this.weight * 1
    },
  },

  watch: {
    'searchNumber': {
      handler: function (val) {
        if (!val) return
        if (this.timeoutSearchNumber) clearTimeout(this.timeoutSearchNumber)

        this.timeoutSearchNumber = setTimeout(() => {
          if (this.isLoading) return
          this.isLoading = true
          
          caseService.searchByNumber(val)
          .then(data => {  this.cases = data ? data : [] })
          .catch(err => console.log(err))
          .finally(() => (this.isLoading = false))
        }, 300)
      }
    },
    
    'letter.mailType' () {
      this.letter.weight = this.weight > this.minWeight ? this.weight : this.minWeight
    },

    'dialog.props' (val) {
      if (val) {
        this.showPropsContent = false
        this.$nextTick(function () {
          this.showPropsContent = true
        })
      }
    }
  },

  computed: {
    ...mapState('letter', ['sorterIndex', 'filterIndex', 'letterNew']),
    ...mapGetters('letter', ['envelopeFormats', 'letters', 'mailTypes']),


    weight () {
      return this.letter.weight || this.minWeight
    },

    minWeight () {
      return this.letter.mailType && this.letter.mailType.name == "BANDEROL" ? 100 : 1
    },

    weightChecker () {
      return this.letter.weight * 1 >= this.minWeight || "Недопустимый вес"
      // return () => this.letter.weight * 1 >= this.minWeight || "Недопустимый вес"
    },

    items () {
      return this.cases.map(c => {
        const Description = c.number.length > this.descriptionLimit
          ? c.number.slice(0, this.descriptionLimit) + '...'
          : c.number

        return Object.assign({}, c, { Description })
      })
    },

    caseMembers () {
      if (this.letter.courtCase) {
        if (this.letter.courtCase.caseMembers )
          return this.letter.courtCase.caseMembers.map(item => {
            if (item.persona.name)
              return {id:item.id, name: item.persona.name, address: item.persona.address}
            else 
              return {id:item.id, name: item.persona.orgName, address: item.persona.address}
          })  
      } 
      return []
    },

    mailTypesList() {
      return this.mailTypes.filter(item => ["LETTER", "BANDEROL"].includes(item.name))
    },

    $_refresh_allowed () {
      let refresh = !this.dialog.props
      if (this.dialog.confirm) refresh = !this.dialog.confirm
      return refresh
    },

    unformedLetters () {
      let statuses = this.filter.status ? [this.filter.status] : [LetterStatus.new, LetterStatus.requested, LetterStatus.awaiting, LetterStatus.error, LetterStatus.communication_error]
      let list = this.letters.filter(item => statuses.includes(item.status.name)).sort(this.sorter.compare)
      return this.filterByJudge(list)
    },

    preparedLetters () {
      let list =  this.letters.filter(item => item.status.name == LetterStatus.formed).sort(this.sorter.compare)
      if (this.search)
        list = list.filter(item => item.barCode.includes(this.search))
      return this.filterByJudge(list)
    },

    sorterItems () {
      return [
        {title: 'по дате', key: 'date', compare: (a, b) => !b.createDate || b.createDate.localeCompare(a.createDate) || b.id - a.id},
        // {title: 'по адресу', key: 'address', compare: (a, b) => a.address.localeCompare(b.address)},
        {title: 'по ФИО', key: 'addressee', compare: (a, b) => a.addressee.localeCompare(b.addressee)},
        // {title: 'по статусу', key: 'status', compare: (a, b) => a.status.value - b.status.value},
        {title: 'по весу', key: 'weight', compare: (a, b) => a.weight - b.weight},
        {title: 'по типу', key: 'weight', compare: (a, b) => a.envelopeFormat.value - b.envelopeFormat.value},
      ]
    },

    filterItems () {
      return [
        { title: 'все', status: null },
        { title: 'новые', status: LetterStatus.new },
        { title: 'запрошен конверт', status: LetterStatus.requested },
        { title: 'конверт формируется', status: LetterStatus.awaiting },
        { title: 'ошибка формирования конверта', status: LetterStatus.error },
        { title: 'ошибка коммуникации', status: LetterStatus.communication_error },
      ]
    },

    fabItems () {
      return [
        { icon:'add', title:'Добавить новое отправление', action: () =>  this.showNewLetter()},
      ]
    },

    filter () {
      return this.filterItems[this.filterIndex]
    },

    sorter () {
      return this.sorterItems[this.sorterIndex]
    },

    letterItems () {
      let isEnvelopeReady = this.letter ? this.letter.status.name == LetterStatus.formed : false
      let isEnvelopeRequested = this.letter ? [LetterStatus.requested, LetterStatus.awaiting].includes(this.letter.status.name) : false
      let isSessionDocs = this.letter && this.letter.sessionDocs 
                          &&  this.letter.sessionDocs.length == 1 
                          &&  this.letter.sessionDocs[0].name === 'Добавлено из почтового кабинета' 
                          ? true 
                          : false
      return [
        { 
          icon: 'print', 
          title: isSessionDocs ? 'Документы отсутствуют' : 'Распечатать документы', 
          disabled: isSessionDocs,
          action: () => this.$_sessionDoc_openAll(this.letter.sessionDocs) 
        },

        { 
          icon: isEnvelopeReady ? 'print' : 'mail', 
          title: isEnvelopeReady ? 'Распечатать конверт и уведомление' : isEnvelopeRequested ? 'Конверт и уведомление формируются...' : 'Сформировать конверт и уведомление', 
          disabled: isEnvelopeRequested,
          loading: isEnvelopeRequested,
          action: () => this.handleEnvelopeByStatus() },
        { icon: 'add', title: 'Сгенерировать конверт и уведомление', action: () => this.generateConvert(), disabled: !isEnvelopeReady || (this.letter.envelopeFormat && this.letter.envelopeFormat.name==="C6")},
        { icon: 'edit', title: 'Изменить параметры отправления', disabled: isEnvelopeRequested, action: () => this.dialogProps() },
        { icon: 'import_contacts', title: 'Передать для формирования реестра', disabled: !isEnvelopeReady, action: () => this.prepareLetterToRegistry()},
        { icon: 'delete', title: 'Удалить', action: () => this.$refs.deleteLetter.show()},
        
      ]
    },
  },

  data () {
    let letterDefault = {
      status: {},
      envelopeFormat: null,
      weight: 0,
      addressee: null,
      address: null,
      addresseeDefault: null,
      addressDefault: null,
      mailType: null,
      courtCase: null
    }
    return {
      search: null, 

      dialog: {
        letter: false,
        props: false,
        confirm: false,
        delete: false,
      },
      showPropsContent: true,

      letterDefault: letterDefault,
      letter: Object.assign({}, letterDefault),
      sessionDoc: {
        name: '',
        selectedMembers: []
      },
      cases: [],
      caseMember: "",
      descriptionLimit: 60,
      isLoading: false,
      searchNumber: null,
      timeoutSearchNumber: null
    }
  }
}

</script>

<style scoped>
  .done-btn {
    right: calc(50% - 205px);
    bottom: 25px;
  }
</style>